(() => {
  document.documentElement.classList.remove('no-js');
  const dialogTriggers = new WeakMap();
  const openDialog = (dialog, trigger) => {
    if (!dialog || typeof dialog.showModal !== 'function') return;
    dialogTriggers.set(dialog, trigger);
    dialog.showModal();
    document.body.classList.add('dialog-open');
    const input = dialog.querySelector('input[type="search"]');
    if (input) input.focus();
  };
  document.addEventListener('click', event => {
    const opener = event.target.closest('[data-dialog-open], [data-search-open]');
    if (opener) {
      const id = opener.dataset.dialogOpen || 'SearchDialog';
      const dialog = document.getElementById(id);
      if (dialog && typeof dialog.showModal === 'function') {
        event.preventDefault();
        openDialog(dialog, opener);
      }
    }
    const closer = event.target.closest('[data-dialog-close]');
    if (closer) closer.closest('dialog')?.close();
    const navigationLink = event.target.closest('.mobile-navigation a');
    if (navigationLink) navigationLink.closest('dialog')?.close();
    if (event.target.tagName === 'DIALOG') {
      const box = event.target.getBoundingClientRect();
      if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) event.target.close();
    }
  });
  const bindDialogs = () => document.querySelectorAll('dialog').forEach(dialog => {
    if (dialog.dataset.bound) return;
    dialog.dataset.bound = 'true';
    dialog.addEventListener('close', () => {
      if (!document.querySelector('dialog[open]')) document.body.classList.remove('dialog-open');
      dialogTriggers.get(dialog)?.focus();
    });
  });
  bindDialogs();
  document.addEventListener('shopify:section:load', bindDialogs);
})();
